<template>
  <div class="row px-3">
    <div class="col-md-4">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-drop-down
          v-model="value.documentType"
          :clearable="false"
          custom-error-msg="Favor de seleccionar el tipo el documento."
          :disabled="readonly"
          :error="errors[0]"
          fieldkey="id"
          fieldname="name"
          label="Tipo de Documento:"
          :options="documentTypes"
          placeholder="Seleccione"
        />
        <!-- 30189 -->
      </validation-provider>
    </div>
    <div class="col-md-4 mt-2">
      <div class="font-14 color-gray-6 ml-3 mb-1">
        Archivo:
      </div>
      <div class="font-14 color-black">
        <div class="d-flex align-align-items-center">
          <span class="color-black font-16 mr-3">
            {{
              value.details != undefined
                ? value.details.selectedDocumentFilename
                : ''
            }}
          </span>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              ref="attachedDocument"
              v-model="value.selectedDocument"
              :accept="'.pdf'"
              :attachment-id="value.documentId"
              class="file-input__extended"
              custom-error-msg="Favor de anejar un documento."
              :disabled="readonly"
              display-style="normal"
              :error="errors[0]"
              label-position="left"
              :name="
                value.documentId != undefined && value.selectedDocument == null
                  ? value.documentName
                  : ''
              "
              :on-download="onDownload"
              required
            />
          </validation-provider>
        </div>
      </div>
    </div>
    <div v-if="!readonly" class="col-md-4 mt-3 text-right pt-2">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
        @click="onCancel"
      />
      <action-button
        i="fas fa-file-plus"
        text="Añadir"
        variant="success pl-4 pr-4"
        @click="onAdd"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomFileInput from 'CustomFileInput';

export default {
  name: 'DocumentManagement',
  components: { ActionButton, CustomDropDown, CustomFileInput },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    documentTypes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onAdd() {
      this.$emit('add-document');
    },
    onDownload(documentId) {
      this.$emit('download-document', documentId);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input__extended ::v-deep {
  .file-input-container {
    line-height: 1.4;
  }
}
</style>
